import Divider from '@mui/material/Divider';
import { useHistory } from 'react-router-dom'
import AudioTable from './NoiseAudioTable';
import { useState } from 'react';


const Audio = () => {
    return (
        <div>
            <div style={{ fontSize: "40px" }}>Audio</div>
            {/*<div style={{ fontSize: "20px" }}>Noise Audio</div>*/}
            <br />
            <div style={{ height: '750px' }}>
                <AudioTable />
            </div>
        </div>
    )
}

export default Audio;